import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    userLoading: true,
    userError: false,
    refreshUser: true,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
    },
    setUserLoading: (state, action) => {
      state.userLoading = action.payload
    },
    setUserError: (state, action) => {
      state.userError = action.payload
    },
    setRefreshUser: (state, action) => {
      state.refreshUser = action.payload
    },
  },
})

export const { setUser, setUserLoading, setUserError, setRefreshUser } = slice.actions

export default slice.reducer
